export default {
    GET_PAIR_COIN_SCALES: (state) => state.pairCoinScales,
    GET_MY_STAKE_DETAIL: (state) => state.myStakeDetail,
    GET_MY_STAKE_DATA: (state) => state.myStakeData
};
